//TABS
$('.btn-tab-anchor').on('click', function(){
    var tabID = $(this).attr('data-tab');
    var sectionID = $(this).attr('href');
    $(sectionID + ' .menu-tabs .btn-tab').removeClass('active');
    $(sectionID + ' .tab').removeClass('active');
    $('#btn-' + tabID).addClass('active');
    $('#tab-' + tabID).addClass('active');
});
$('.section-tabs .menu-tabs .btn-tab').on('click', function () {
    var tabID = $(this).attr('data-tab');
    var tab_parent = $(this).closest('.section-tabs');
    $('.menu-tabs .btn-tab, .tab', tab_parent).removeClass('active');
    $(this).addClass('active');
    $('#tab-' + tabID).addClass('active');
})